import { NFLookupCatalog } from "./NFLookupCatalog";
import { AppEntities } from "../../../config/entities";
import { NFLookupCatalogColumn } from "./NFLookupCatalogColumn";
import React from "react";
interface IProps {
  title?: string;
  fieldName: string;
  required?: boolean;
  showBorder?: boolean;
  width?: number;
  selectedCatalog?: boolean;
  setSelectedCatalog?: (value: boolean) => void;
}

export const NFLookupVendorItem = ({
  title,
  fieldName,
  required,
  showBorder,
  width,
  selectedCatalog,
  setSelectedCatalog,
}: IProps) => {
  const loadData = async (searchText: string | undefined) => {
    return await AppEntities.VendorItem.getDataService().GetAll(searchText);
  };

  return (
    <>
      <NFLookupCatalog
        fieldName={fieldName}
        title={title}
        entity={AppEntities.VendorItem}
        width={width}
        serverData={loadData}
        required={required}
        showBorder={showBorder}
        selectedCatalog={selectedCatalog}
        setSelectedCatalog={setSelectedCatalog}
      >
        <NFLookupCatalogColumn fieldName={"name"} caption={"Name"} />
      </NFLookupCatalog>
    </>
  );
};
